import { CaseNameForm } from './CaseNameForm'
import { useOpenTrialCase } from './useOpenTrialCase'

export const LiveCaseForm = () => {
  const { openCase, isOpening } = useOpenTrialCase()
  return <CaseNameForm isOpening={isOpening} onOpen={openCase} />
}
